import { useNavigate, useLocation } from 'react-router-dom'
import { AuthLayout } from '../../layout.tsx'
import { Button } from '@/app/common/components/button/Button.tsx'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import { useState } from 'react'
import { SendResetPasswordEmail } from '@/apis/users/requests.ts'
import { useAppAlert } from '@/layouts/AppAlertProvider.tsx'
import { CircleLoader } from '@/common/components/CircleLoader.tsx'
import AceScholarshipsLogo from '@assets/AceScholarshipLogo1.jpg'

export default function CheckEmailPage() {
  const navigate = useNavigate()
  const { state } = useLocation()
  const [loading, setLoading] = useState(false)
  const { fireAlert } = useAppAlert()

  const handleLogin = () => {
    navigate(AppRoutePaths.auth.login)
  }

  const handleResend = async () => {
    setLoading(true)
    const { error, data } = await SendResetPasswordEmail(state.email)
    setLoading(false)
    if (error) {
      await fireAlert({
        variant: 'error',
        message: error.message,
      })
      navigate(AppRoutePaths.auth.login)
    } else {
      await fireAlert({
        variant: 'success',
        message: data.message,
      })
    }
  }

  return (
    <AuthLayout>
      <AuthLayout.Content>
        <div className="flex flex-col">
          <img
            alt={'ace_logo'}
            src={AceScholarshipsLogo}
            className="mx-auto h-auto"
            width="100%"
          />
          <h3 className="text-lg font-semibold text-gray-900 text-center mt-10 mb-4">
            Check your email
          </h3>
          <div className="text-sm text-gray-500 font-medium text-center mb-7">
            <p>
              If the email is registered with us, a password reset link and
              instructions will be sent to the address.
            </p>
          </div>
          <div className="flex justify-center mb-5">
            <Button onClick={handleLogin}>Log In</Button>
          </div>
          <div className="flex items-center justify-center gap-1 mt-8">
            <span className="text-xs font-medium text-gray-500">
              Didn’t receive an email?
            </span>
            {loading ? (
              <CircleLoader size="sm" className="mr-1" />
            ) : (
              <a
                className="text-xs font-medium link text-primary cursor-pointer"
                onClick={handleResend}
              >
                Resend
              </a>
            )}
          </div>
        </div>
      </AuthLayout.Content>
    </AuthLayout>
  )
}
